import { IConfig } from '@cian/config/shared';
import {
  DEFAULT_TIMEOUT_MS,
  REGION_FILTER_RS_KEY,
  TIMEOUT_RS_KEY,
  isDynamicCalltrackingEnabled,
  requestDynamicPhone,
  IRegionFilter,
  IOfferGeoLike,
  IRequestDynamicPhoneDeps,
  IRequestDynamicPhoneParams,
  TDynamicPhoneResult,
} from '@cian/frontend-offer-dynamic-calltracking';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';

import { IValidPhone } from '../types/offerData';

// Подпись пока никто не рендерит: её подключают точки карточки в CD-287163, CD-287164, CD-287165
// ts-unused-exports:disable-next-line
export const DYNAMIC_PHONE_WARNING_TEXT = 'Это временные номера, не сохраняйте их';
export const DYNAMIC_PHONE_ERROR_TEXT = 'Что-то пошло не так, попробуйте позже';

/**
 * Включён ли динКТ вторички для объявления: региональный фильтр раскатки
 * из RS (offerDynamicCalltracking.regionFilter) + регион из offer.geo.
 * Ключа в RS нет — выключено, точка работает по-старому.
 */
export function getIsOfferDynamicCalltrackingEnabled(config: IConfig, geo: IOfferGeoLike | null | undefined): boolean {
  return isDynamicCalltrackingEnabled({
    regionFilter: config.get<IRegionFilter>(REGION_FILTER_RS_KEY),
    geo,
  });
}

interface IRequestOfferDynamicPhoneDeps {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
}

export function requestOfferDynamicPhone(
  params: IRequestDynamicPhoneParams,
  { config, httpApi, logger }: IRequestOfferDynamicPhoneDeps,
): Promise<TDynamicPhoneResult | null> {
  const deps: IRequestDynamicPhoneDeps = {
    httpApi,
    logger,
    timeoutMs: config.get<number>(TIMEOUT_RS_KEY) ?? DEFAULT_TIMEOUT_MS,
  };

  return requestDynamicPhone(params, deps);
}

/**
 * Контракт КТ отдаёт номер строкой (`+79991234567` / `79991234567` / `89991234567`),
 * вёрстка карточки ждёт `IValidPhone` — приводим к `{countryCode: '+7', number: <10 цифр>}`
 */
export function mapCalltrackingPhoneToValidPhone(phone: string): IValidPhone {
  const digits = phone.replace(/\D/g, '');

  return { countryCode: '+7', number: digits.slice(-10) };
}
